
(function () {
  var DESCRIPTION = 'Delivered On Your Schedule. Skip, Edit, Or Cancel Anytime';
  var SAVE_LABEL  = 'Save {amount}';   // {amount} is replaced with the saving, e.g. $2.00
  var WIDGET_TITLE = 'How do you want it?';

  function parsePrice(text) {
    var m = (text || '').match(/\d[\d.,]*/);
    if (!m) return null;
    return { raw: m[0], value: parseFloat(m[0].replace(/,/g, '')) };
  }

  function setText(el, text) {
    if (el.textContent !== text) el.textContent = text;   // only write when changed (avoids observer loops)
  }

  function updateWidgets() {
    // Heading: "Purchase Options" -> "How do you want it?"
    document.querySelectorAll('.appstle_widget_title').forEach(function (title) {
      setText(title, WIDGET_TITLE);
    });

    // The "Subscribe and save" option is the one that contains the dropdown wrapper
    var options = document.querySelectorAll('.appstle_subscription_wrapper_option.appstle_include_dropdown');

    options.forEach(function (opt) {
      var badge   = opt.querySelector('.appstle-save-badge');
      var desc    = opt.querySelector('.appstle_subscription_description_text');
      var saleEl  = opt.querySelector('.appstle_subscription_amount');
      var compEl  = opt.querySelector('.appstle_subscription_compare_amount');

      // Description text
      if (desc) {
        desc.classList.add('appstle-desc-added');
        setText(desc, DESCRIPTION);
      }

      // Saving badge
      if (badge && saleEl && compEl) {
        badge.classList.add('appstle-save-added');
        var sale = parsePrice(saleEl.textContent);
        var comp = parsePrice(compEl.textContent);

       if (sale && comp && comp.value > sale.value) {
  var diff = (comp.value - sale.value).toFixed(2);
  var amountText = saleEl.textContent.trim().replace(sale.raw, diff);

  badge.style.display = 'flex'; // or 'inline-flex'
  badge.classList.add('appstle-save-added');

  setText(badge, SAVE_LABEL.replace('{amount}', amountText));
} else {
  badge.style.display = 'none';
  badge.classList.remove('appstle-save-added');
  setText(badge, '');
}
      }
    });
  }

  // The widget loads late and re-renders on variant change, so watch the DOM
  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(updateWidgets, 50);
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });

  updateWidgets();
  document.addEventListener('DOMContentLoaded', updateWidgets);
  window.addEventListener('load', updateWidgets);
})();

